<template>
  <v-dialog
    v-model="dialogShowAddNew"
    persistent
    max-width="75%"
    class="pb-10"
    :retain-focus="false"
    style="z-index: 202"
  >
    <v-card class="pt-4 pl-10 pr-10 pb-4 rounded-0" height="auto">
      <FullLoading :loading="loading" style="margin-top: 30vh;"/>
      <div class="">
        <span class="black--text font-weight-bold mr-5">เพิ่มสายบังคับบัญชา</span>
        <v-btn absolute right top icon x-small @click="closeShowPreview()"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-divider class="mt-4 mb-4"/>
      <div class="text-center" justify="start">
        <v-row class="mb-0" align="center" style="margin-top: -10px;">
          <v-col cols="2" class="text-right" style="margin-top: -5px;">
          <span >ชื่อสายบังคับบัญชา :</span>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
                v-model="structureForAdd.type"
                :items="itemStructures"
                item-text="name"
                item-value="name"
                :rules="rulesSelectitemStructures"
                :background-color="allowFocusItem? 'white':'#FAFAFA'"
                outlined
                placeholder="เลือกประเภทงาน"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                :disabled="!allowFocusItem"
              >
              </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="structureForAdd.title"
              :background-color="allowFocusItem? 'white':'#FAFAFA'"
              outlined
              :disabled="!allowFocusItem"
              :rules="rulesInputCommand"
              placeholder="ระบุชื่อสายบังคับบัญชา"
              no-data-text="ไม่พบข้อมูล"
              class="mt-2"
              dense
              @keydown.space="preventLeadingSpace"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row style="margin-top: -25px;" align="center">
          <v-col cols="2" class="text-right" >
            <v-checkbox
              style="margin-top: 6px; margin-left: 15%;"
              color="#2BA197"
              v-model="structureForAdd.orgChartHeader"
              :disabled="!allowFocusItem"
              @change="toggleLeader()"
            >
            <template #append>
              <span class="text-no-wrap black--text text--darken-0" style="margin-top: 5px; font-size: 15.5px;">ผู้บังคับบัญชา : </span>
            </template>
            </v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
                v-model="structureForAdd.searchLeader"
                :items="itemLeaders"
                item-text="dataShow"
                return-object
                outlined
                placeholder="ค้นหาผู้บังคับบัญชา"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                :background-color="structureForAdd.orgChartHeader? 'white':'#FAFAFA'"
                :disabled="!structureForAdd.orgChartHeader"
                @change="selectedLeader()"
                @keyup="getSelectLeader($event.target.value)"
              >
              </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="structureForAdd.position"
              :background-color="'#FAFAFA'"
              outlined
              placeholder="ตำแหน่ง"
              no-data-text="ไม่พบข้อมูล"
              class="mt-2"
              dense
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="structureForAdd.leaderTemp"
              color="#2BA197"
              outlined
              :class="structureForAdd.leaderTemp? 'border-black-box-checked pt-3 ml-0':'border-black-box pt-3 ml-0'"
              style="height: 36px; margin-top: -7px; padding-left: 10px;"
              height="12"
              :disabled="!structureForAdd.leaderId"
            >
            <template v-slot:label>
              <span class="text-no-wrap grey--text text--darken-1 pr-2 ma-0 pa-0 mt-0" style="font-size: 14px;">รักษาการแทน</span>
            </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-divider class="" style="margin-top: -10px;"/>
        <v-row class="mb-0"  align="center" style="margin-top: -10px;">
          <v-col cols="2" class="text-right" >
          <span >ประเภท :</span>
          </v-col>
          <v-col cols="8">
            <v-radio-group
              v-model="structureForAdd.typeAdd"
              row
            >
              <v-radio
                class="border-black-box pa-1"
                style="width: 140px;"
                color="#2BA197"
                label="Parent (root)"
                value="parent"
                :disabled="!allowFocusItem"
                v-if="focusIndex!==topIndex"
              ></v-radio>
              <v-radio
                class="border-black-box pa-1"
                style="width: 140px;"
                color="#2BA197"
                label="Child"
                value="child"
                :disabled="!allowFocusItem"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="2">
            <v-btn
              color="#2BA197"
              class="mt-2 white--text"
              elevation="0"
              block
              :disabled="!allowAddNode"
              @click="submitAddNewStucture()"
            >
              <span class="ra-text-in-button" style="white-space: normal; letter-spacing: 0.4px;">
                เพิ่มสายบังคับบัญชา
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { FullLoading } from '@/components/index'
import { getUserByEmployee } from '@/API/API'
export default {
  props: {
    topIndex: String,
    focusIndex: String,
    itemLeaders: Array,
    itemStructures: Array,
    dialogShowAddNew: Boolean
  },
  components: {
    FullLoading
  },
  name: 'dialog-add-new-stucture',
  data () {
    return {
      structureForAdd: {},
      loading: true,
      rulesSelectitemStructures: [
        v => !!v || 'กรุณาเลือกประเภทงาน'
      ],
      rulesInputCommand: [
        v => !!v || 'กรุณาระบุชื่อสายบังคับบัญชา'
      ]
    }
  },
  watched: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  computed: {
    allowFocusItem () {
      return true
    },
    allowAddNode () {
      var result = this.structureForAdd.title && this.structureForAdd.typeAdd && this.structureForAdd.type && (!((this.structureForAdd.orgChartHeader === true && !this.structureForAdd.leaderId)))
      return result
    }
  },
  async created () {
    await this.setBaseStructure()
    this.loading = false
    // console.log('เพิ่มสายบังคับบัญชา', this.structureForAdd)
  },
  methods: {
    // ป้องกันการกรอก Spacebar
    preventLeadingSpace (e) {
      // ป้องกันการกด spacebar ถ้ายังไม่มีการกรอกข้อมูล
      if (!e.target.value) e.preventDefault()
      // ถ้าหากอักขระนำหน้าเป็นช่องว่าง ให้ลบช่องว่างนำหน้าทั้งหมดออก
      else if (e.target.value[0] === ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    async getSelectLeader (value) {
      var temp = []
      if (value) {
        var payload = {
          companyId: '',
          name: value
        }
      }
      const token = this.$store.state.token
      try {
        const res = await getUserByEmployee(payload, token)
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              temp.push({
                dataShow: el.employeeId + ' - ' + el.titleTh + el.name,
                ...el
              })
            })
            this.itemLeaders = temp
          }
        } else {
        }
      } catch (error) {
        this.itemLeaders = []
      } finally {
      }
    },
    async closeShowPreview () {
      await this.$emit('closeDialogAddNewStucture')
    },
    async submitAddNewStucture () {
      this.loading = true
      await this.$emit('submitAddNewStucture', this.structureForAdd)
      this.loading = false
    },
    async setBaseStructure () {
      this.structureForAdd = {
        id: Math.floor(100000 + Math.random() * 900000),
        pid: null,
        title: '',
        type: null,
        typeAdd: null,
        orgChartLeader: null,
        orgChartHeader: false,
        searchLeader: null,
        name: null,
        position: null,
        leaderId: null,
        leaderTemp: false,
        children: []
      }
    },
    selectedLeader () {
      var tempLeader = JSON.parse(JSON.stringify(this.structureForAdd.searchLeader))
      this.structureForAdd.name = tempLeader.titleTh + tempLeader.firstNameTh + ' ' + tempLeader.lastNameTh
      this.structureForAdd.position = tempLeader.position
      this.structureForAdd.leaderId = tempLeader.employee_id
    },
    toggleLeader () {
      if (this.structureForAdd.orgChartHeader === false) {
        this.structureForAdd.searchLeader = null
        this.structureForAdd.name = null
        this.structureForAdd.position = null
        this.structureForAdd.leaderId = null
        this.structureForAdd.leaderTemp = false
      }
    }
  }
}
</script>
